import { render, staticRenderFns } from "./PerfilBottomNav.vue?vue&type=template&id=081b3346&scoped=true"
import script from "./PerfilBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilBottomNav.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PerfilBottomNav.vue?vue&type=style&index=0&id=081b3346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b3346",
  null
  
)

export default component.exports